import { createSlice } from "@reduxjs/toolkit";
import { getCustomersByTenantId } from "./thunks";

const initialState = {
  customersByTenants: {},
  loading: true,
};

const customersReducerSlice = createSlice({
  name: "customers",
  initialState,
  reducers: {
    setKeyValue: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCustomersByTenantId.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCustomersByTenantId.fulfilled, (state, action) => {
        const { tenant_id } = action.meta.arg;
        const { data } = action.payload;

        state.customersByTenants[tenant_id] = data;
        state.loading = false;
      })
      .addCase(getCustomersByTenantId.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setKeyValue } = customersReducerSlice.actions;

export default customersReducerSlice.reducer;
